/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {
    @Serenity.Decorators.registerClass()
    export class ServiceOutwardDetailsGrid extends _Ext.ItemGridEditor<ServiceOutwardDetailsRow> {
        protected getColumnsKey() { return 'Finance.ServiceOutwardDetails'; }
        protected getDialogType() { return ServiceOutwardDetailsDialog; }
        protected getIdProperty() { return ServiceOutwardDetailsRow.idProperty; }
        protected getInsertPermission() { return ServiceOutwardDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceOutwardDetailsRow.localTextPrefix; }
        protected getService() { return ServiceOutwardDetailsService.baseUrl; }
      

        //#endregion


    }
}